import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import { type AcquisitionIndicators } from '@/domain/acquisition/types';
import { formatAcquisitionCount } from '@/domain/acquisition/utils';
import { useTranslate } from '@/state/i18n';
import { radiusTokens } from '@/theme/themePrimitives';

interface Props {
  indicators: AcquisitionIndicators;
}

/** Totals of the window over every link: clicks, signups and, of those, who already pays. */
const AcquisitionIndicatorsStrip = ({ indicators }: Props) => {
  const t = useTranslate('domain.acquisition.components.AcquisitionIndicatorsStrip');

  const items = [
    {
      label: t('clicks'),
      value: formatAcquisitionCount(indicators.clicks),
      hint: t('clicksHint', { count: indicators.uniqueClicks }),
    },
    {
      label: t('signups'),
      value: formatAcquisitionCount(indicators.signups),
      hint: t('signupsHint'),
    },
    {
      label: t('paying'),
      value: formatAcquisitionCount(indicators.paying),
      hint: t('payingHint'),
    },
  ];

  return (
    <Box sx={sx.grid}>
      {items.map((item) => (
        <Paper key={item.label} variant="outlined" sx={sx.card}>
          <Typography variant="caption" color="text.secondary">
            {item.label}
          </Typography>
          <Typography variant="h3" component="p">
            {item.value}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {item.hint}
          </Typography>
        </Paper>
      ))}
    </Box>
  );
};

export default AcquisitionIndicatorsStrip;

const sx = {
  grid: {
    display: 'grid',
    gap: 2,
    gridTemplateColumns: { xs: 'minmax(0, 1fr)', sm: 'repeat(3, minmax(0, 1fr))' },
  },
  card: {
    borderRadius: radiusTokens.xxl,
    p: 2,
    display: 'flex',
    flexDirection: 'column',
    gap: 0.5,
  },
};
